export default {
  API_ENDPOINT: 'https://young-garden-84985.herokuapp.com/api',
  // API_ENDPOINT: 'http://localhost:8000/api',
  TOKEN_KEY: process.env.REACT_APP_API_KEY,
}
